import XPZSOLARFLOW from './XPZ-SOLARFLOW';
import XPZSOLARFLOW1200 from './XPZ-SOLARFLOW1200';
import XPZSOLARFLOW2000 from './XPZ-SOLARFLOW2000';
import XPZACE1500 from './XPZ-ACE1500';
import XPZAIO2400 from './XPZ-AIO2400';
import XPZHYPER2000 from './XPZ-HYPER2000';
import XPZHUB1200 from './XPZ-HUB1200';

export const Zendure = {
	'XPZ-SOLARFLOW': XPZSOLARFLOW,
	'XPZ-SOLARFLOW1200': XPZSOLARFLOW1200,
	'XPZ-SOLARFLOW2000': XPZSOLARFLOW2000,
	'XPZ-ACE1500': XPZACE1500,
	'XPZ-AIO2400': XPZAIO2400,
	'XPZ-HYPER2000': XPZHYPER2000,
	'XPZ-HUB1200': XPZHUB1200,
};
